import React from "react";
import { Form } from "antd";
import CreateModal from "../../../core/ui/components/grid/CreateModal";
import { PlusCircleFilled } from "@ant-design/icons";
import CaseLawDocumentTypeCategoryAssignationForm from "../../../caseLawDocuments/ui/components/CaseLawDocumentTypeCategoryAssignationForm";
import { IOrganisationIndexCategory } from "../../model/OrganisationIndexCategory";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import { IDocumentTypeIndexCategory } from "../../../documentTypes/model/DocumentTypeIndexCategory";
import OrganisationDocumentTypeForm from "./OrganisationDocumentTypeForm";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import { IVisibilityLevel } from "../../../documentTypes/model/VisibilityLevel";
import { DocumentStatus } from "../../../core/common/Constants";
interface OrganisationCaseLawDocumentTypeGridProps {
  translate: any;
  organisationId: number;
  organisationCaseLawDocumentTypes: IDocumentType[];
  caseLawDocumentTypeIndexCategories: IDocumentTypeIndexCategory[];
  referenceLoader?: boolean;
  modalVisible: boolean;
  addCaseLawDocumentTypeIndexCategories;
  organisationIndexCategories: IOrganisationIndexCategory[];
  currentCaseLawDocumentTypeCode?: number;
  onChangeAddElementsModalVisible: (value: boolean, code?: number) => void;
  addCaseLawDocumentTypeToOrganisation;
  setOrganisationCaseLawDocumentTypeData: (value: number) => void;
  caseLawDocumentTypes: IDocumentType[];
  onChangeAddTypesToOrganisationModalVisible;
  assignTypesToOrganisationModalVisible: boolean;
  removeOrganisationCaseLawDocumentType: (id: number) => void;
}
const OrganisationCaseLawDocumentTypeGrid: React.FC<OrganisationCaseLawDocumentTypeGridProps> =
  ({
    translate,
    organisationCaseLawDocumentTypes,
    caseLawDocumentTypeIndexCategories,
    modalVisible,
    onChangeAddElementsModalVisible,
    addCaseLawDocumentTypeIndexCategories,
    organisationIndexCategories,
    currentCaseLawDocumentTypeCode,
    addCaseLawDocumentTypeToOrganisation,
    setOrganisationCaseLawDocumentTypeData,
    caseLawDocumentTypes,
    organisationId,
    removeOrganisationCaseLawDocumentType
  }) => {
    const builder = DataGridConfigurationBuilder({
      translate,
      resourcePrefix: "editors.case_law_document_types"
    });
    const gevVisibilityLevels = (
      visibilityLevels: IVisibilityLevel[],
      status: string
    ) => {
      return visibilityLevels?.find((item) => item.status === status)
        ?.visibilityLevel;
    };

    const columns = builder.buildColumns(
      "name",
      {
        name: `${DocumentStatus.IN_PROGRESS}`,
        sortable: false,
        align: "center",
        render: (record) => (
          <span>
            {translate(
              `editors.visibility_levels.${gevVisibilityLevels(
                record.visibilityLevels,
                DocumentStatus.IN_PROGRESS
              )}`
            )}
          </span>
        )
      },
      {
        name: `${DocumentStatus.RECORDED}`,
        sortable: false,
        align: "center",
        render: (record) => (
          <span>
            {translate(
              `editors.visibility_levels.${gevVisibilityLevels(
                record.visibilityLevels,
                DocumentStatus.RECORDED
              )}`
            )}
          </span>
        )
      },
      {
        name: `${DocumentStatus.VERIFIED}`,
        sortable: false,
        align: "center",
        render: (record) => (
          <span>
            {translate(
              `editors.visibility_levels.${gevVisibilityLevels(
                record.visibilityLevels,
                DocumentStatus.VERIFIED
              )}`
            )}
          </span>
        )
      },
      {
        name: `${DocumentStatus.PUBLISHED}`,
        sortable: false,
        align: "center",
        render: (record) => (
          <span>
            {translate(
              `editors.visibility_levels.${gevVisibilityLevels(
                record.visibilityLevels,
                DocumentStatus.PUBLISHED
              )}`
            )}
          </span>
        )
      },
      {
        name: `${DocumentStatus.ARCHIVED}`,
        sortable: false,
        align: "center",
        render: (record) => (
          <span>
            {translate(
              `editors.visibility_levels.${gevVisibilityLevels(
                record.visibilityLevels,
                DocumentStatus.ARCHIVED
              )}`
            )}
          </span>
        )
      },
      {
        name: `${DocumentStatus.INVALIDATED}`,
        sortable: false,
        align: "center",
        render: (record) => (
          <span>
            {translate(
              `editors.visibility_levels.${gevVisibilityLevels(
                record.visibilityLevels,
                DocumentStatus.INVALIDATED
              )}`
            )}
          </span>
        )
      },

      {
        name: "",
        dataKey: "valid",
        sortable: false,
        align: "center",
        render: (record) => (
          <div
            onClick={() => onChangeAddElementsModalVisible(true, record.id)}
            style={{
              marginLeft: "0.75em",
              marginTop: "0.15em",
              cursor: "pointer"
            }}
            title={translate(
              "editors.case_law_document_types_index_organisations.case_law_document_types_index_organisations"
            )}
          >
            <PlusCircleFilled style={{ fontSize: "120%" }} />
          </div>
        )
      }
    );

    const [CreateForm] = Form.useForm();
    const [UpdateForm] = Form.useForm();

    return (
      <div>
        <CreateModal
          translate={translate}
          title={translate(
            "editors.case_law_document_types_index_organisations.case_law_document_types_index_organisations"
          )}
          visible={modalVisible}
          onCancel={() => {
            onChangeAddElementsModalVisible(false);
            CreateForm.resetFields();
          }}
          onCreate={addCaseLawDocumentTypeIndexCategories}
          Form={
            <CaseLawDocumentTypeCategoryAssignationForm
              translate={translate}
              form={CreateForm}
              caseLawDocumentTypeCode={currentCaseLawDocumentTypeCode}
              organisationIndexCategories={organisationIndexCategories}
            />
          }
          formInstance={CreateForm}
          rowData={{ fields: caseLawDocumentTypeIndexCategories }}
          className={"modal-width"}
          okText={translate("data_grid.modal.actions.save")}
          cancelText={translate("data_grid.modal.actions.cancel")}
        />
        <DataGrid
          title={translate("editors.case_law_document_types.title")}
          columns={columns}
          translate={translate}
          dataSource={organisationCaseLawDocumentTypes || []}
          allowCreate={true}
          allowUpdate={true}
          addButtonText={translate(
            "editors.case_law_document_types.add_new_text"
          )}
          createForm={
            <OrganisationDocumentTypeForm
              translate={translate}
              form={CreateForm}
              documentTypes={caseLawDocumentTypes}
              organisationId={organisationId}
              placeholder={translate(
                "editors.case_law_document_types_index_organisations.select_document_type"
              )}
            />
          }
          updateForm={
            <OrganisationDocumentTypeForm
              translate={translate}
              form={UpdateForm}
              documentTypes={caseLawDocumentTypes}
              organisationId={organisationId}
              placeholder={translate(
                "editors.case_law_document_types_index_organisations.select_document_type"
              )}
            />
          }
          createModalTitle={`${translate(
            "editors.case_law_document_types_index_organisations.adding_case_law_document_type_to_organisation"
          )}`}
          updateModalTitle={`${translate(
            "editors.case_law_document_types_index_organisations.edit_case_law_document_type_to_organisation"
          )}`}
          deleteModalTitle={`${translate(
            "editors.case_law_document_types_index_organisations.remove_case_law_document_type_to_organisation"
          )}`}
          deleteModalMessage={`${translate(
            "editors.case_law_document_types_index_organisations.remove_text"
          )}`}
          allowDelete={true}
          onDelete={(e) => removeOrganisationCaseLawDocumentType(e.id)}
          onCreate={(e) => {
            addCaseLawDocumentTypeToOrganisation(e);
          }}
          onUpdate={(e) => {
            addCaseLawDocumentTypeToOrganisation(e);
          }}
          booleanColumnKeys={["valid"]}
          createModalClass={"modal-width"}
          updateModalClass={"modal-width"}
          keyProperty={"id"}
          CreateFormInstance={CreateForm}
          UpdateFormInstance={UpdateForm}
          createActionPosition={"topRight"}
        />
      </div>
    );
  };
export default OrganisationCaseLawDocumentTypeGrid;
